var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenewal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transactions-icon copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-759.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Order-Copy-2",
    transform: "translate(746.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Growth--Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transactions-icon-copy-8",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style",
    opacity: 0,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6931E",
    opacity: 0.159999996,
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-recycle-5105234",
    transform: "translate(8.000000, 8.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2310127,2.41613924 L19.297231,5.75007911 L19.336788,5.72875554 L19.7750079,5.4923394 L20.3841218,5.16352611 C20.5435839,5.07730775 20.7290111,5.0949193 20.8693117,5.20957278 C21.0099209,5.32391614 21.0646282,5.50192247 21.0127057,5.67529272 L20.2014715,10.0589953 C20.1322468,10.2904668 19.8871756,10.4227373 19.655712,10.3535127 L15.5464557,8.62503165 C15.3727769,8.57311313 15.254106,8.42971519 15.2355617,8.24954905 C15.2170174,8.06938291 15.3041685,7.90465981 15.4636313,7.81875 L16.2711472,7.38300633 L16.3644778,7.33263291 L14.4036392,4.16839241 C14.2358307,3.89767247 14.0185759,3.68783861 13.7667089,3.54783861 C13.5194778,3.41031487 13.2283623,3.3376962 12.908481,3.33800475 C12.5886234,3.33831384 12.2975079,3.41186472 12.0505696,3.55000633 C11.8085918,3.68536234 11.5944304,3.89643829 11.4226028,4.17549684 L9.88763449,6.66576582 C9.51184335,5.45587658 8.29364715,4.70492722 7.04388449,4.91291772 L8.57885285,2.42264873 C9.04674051,1.66364557 9.67592563,1.06283861 10.4226028,0.645670886 C11.1639873,0.231248418 12.0064636,0.0112167722 12.906068,0.00996945982 C13.805356,0.00873852848 14.648394,0.226920886 15.3907199,0.639792722 C16.1287025,1.0501962 16.7570174,1.65031487 17.2313845,2.41613766 L17.2310127,2.41613924 Z M0.613132911,15.9849684 L2.36724684,12.4767405 L2.32830775,12.4541804 L1.29737421,11.8589747 C1.14038054,11.7684288 1.05818117,11.6015459 1.08166218,11.4216883 C1.10545807,11.2421392 1.22814953,11.1021392 1.4030625,11.0551693 L5.56057832,9.44567563 C5.79390111,9.38325 6.03495332,9.52262658 6.09769066,9.75564399 L6.78251661,14.1607073 C6.82949051,14.3356203 6.76953718,14.5120839 6.62583149,14.6224082 C6.48212579,14.7327326 6.2963932,14.7450981 6.13940744,14.6542389 L5.34454984,14.1953149 L5.25276187,14.1424691 L3.58796756,17.4720578 C3.44549921,17.7569945 3.38121915,18.052121 3.3938932,18.3398584 C3.40656408,18.6223188 3.49742168,18.9081812 3.66584731,19.1804438 C3.8339644,19.4527065 4.04905934,19.6616147 4.29629035,19.799447 C4.5382682,19.9344945 4.83061788,20.0058869 5.15823655,20.0058869 L8.08363212,20.0058869 C7.25079984,20.9604755 7.25079984,22.3919628 8.08363212,23.3466305 L5.15823655,23.3466305 C4.26662263,23.3466305 3.42516693,23.1259739 2.67817326,22.7093916 C1.93648022,22.2958948 1.30697073,21.6942017 0.834106804,20.9290119 C0.361274525,20.1638299 0.104462816,19.33186 0.0664564873,18.483284 C0.0284446203,17.6399296 0.209850475,16.7900878 0.61283307,15.9843916 L0.613132911,15.9849684 Z M20.8662975,23.2788766 L16.9446203,23.3431566 L16.9427661,23.3882761 L16.9211331,23.8858315 L16.8911561,24.5774612 C16.8831213,24.7585609 16.7731023,24.9087508 16.6028254,24.9705625 C16.4325485,25.0326796 16.2517574,24.988178 16.129376,24.8546764 L12.7819077,21.9104517 C12.6187352,21.7324454 12.6307843,21.454004 12.8087937,21.2908315 L16.3998539,18.648822 C16.5333586,18.5264407 16.7172352,18.498015 16.8816419,18.5746527 C17.04574,18.6512943 17.1424725,18.8101432 17.1344346,18.991235 L17.0945683,19.9081653 L17.0899328,20.0138536 L20.8120055,19.9526638 C21.130621,19.9474101 21.4220451,19.8682967 21.6711036,19.7239771 C21.9158663,19.5821258 22.1275514,19.3695071 22.291341,19.0944676 C22.4551305,18.8197286 22.5410403,18.532015 22.5493869,18.2492144 C22.5574217,17.9723157 22.4857247,17.679966 22.3342919,17.3891669 L20.9831843,14.7944676 C22.2146717,15.092379 23.4842128,14.4313505 23.9462381,13.251746 L25.2973457,15.8464454 C25.7089834,16.6372761 25.9021321,17.4856068 25.8777176,18.3403536 C25.8536123,19.189246 25.6103995,20.0255593 25.1502413,20.7981068 C24.6900831,21.5707017 24.0704945,22.1829169 23.3355261,22.6084707 C22.6049565,23.0315483 21.7674881,23.2633204 20.8669343,23.2781543 L20.8662975,23.2788766 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewal);
export default __webpack_public_path__ + "static/media/Renewal.f1d19f4524488a34dc8f439043ddc918.svg";
export { ForwardRef as ReactComponent };